export default __webpack_public_path__ + "static/media/prodeseg_login.dc9c2ea3.png";